import Fuse from 'fuse.js/dist/fuse.basic.esm';

export default class Searcher {
  constructor(collection, { keys = ['name'] } = {}, fuseOptions = {}) {
    let list = collection;
    if (list instanceof Map) {
      list = [...list.values()];
    } else if (list[Symbol.iterator]) {
      list = [...list];
    } else {
      list = Object.values(list);
    }
    this.fuse = new Fuse(list, { keys: keys, ignoreLocation: true, threshold: 0.4, ...fuseOptions });
  }

  search(term) {
    return this.fuse.search(term).map(x => x.item);
  }
}
